<template>
  <div id="app">
    <router-view />
    <AppFooter />
    <!-- 전역 Player 컴포넌트 - 모든 페이지에서 공유 -->
    <Player
      ref="globalPlayerRef"
      :global-mode="true"
    />
    <!-- 전역 커스텀 알럿 -->
    <CustomAlert
      v-if="alertState.visible"
      :message="alertState.message"
      :type="alertState.type"
      :confirm-text="alertState.confirmText"
      @confirm="handleAlertConfirm"
      @close="alertState.visible = false"
    />
  </div>
</template>

<script setup>
import { ref, provide } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth.js'
import AppFooter from '@/components/AppFooter.vue'
import Player from '@/components/Player.vue'
import CustomAlert from '@/components/CustomAlert.vue'
import { alertState } from '@/utils/customAlert.js'

const router = useRouter()
const authStore = useAuthStore()
const globalPlayerRef = ref(null)

// 전역 Player를 provide로 제공하여 하위 컴포넌트에서 접근 가능하게 함
provide('globalPlayer', globalPlayerRef)

// 알럿 확인 핸들러
const handleAlertConfirm = () => {
  if (alertState.value.onConfirm) {
    alertState.value.onConfirm()
  }
}
</script>

<style>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html {
  overflow-x: hidden;
  width: 100%;
}

body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  width: 100%;
  font-family: 'Noto Sans KR', Avenir, Helvetica, Arial, sans-serif;
}

@media (max-width: 430px) {
  html, body, #app {
    max-width: 100vw !important;
    width: 100vw !important;
    overflow-x: hidden !important;
    box-sizing: border-box !important;
  }
}

#app {
  font-family: 'Noto Sans KR', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
  width: 100%;
  min-width: 0;
}

.body {
  font-family: 'Noto Sans KR', 'Arial', sans-serif;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f172a 100%);
  color: #ffffff;
  min-height: 100vh;
  overflow-x: hidden;
  width: 100%;
  min-width: 0;
}

/* 전역 커스텀 스크롤바 디자인 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(45deg, #ff6b6b, #4ecdc4);
  border-radius: 10px;
  border: 2px solid rgba(255, 255, 255, 0.1);
}

::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(45deg, #ff5252, #26c6da);
  box-shadow: 0 2px 8px rgba(255, 107, 107, 0.3);
}

::-webkit-scrollbar-corner {
  background: transparent;
}

/* Firefox용 스크롤바 */
* {
  scrollbar-width: thin;
  scrollbar-color: #4ecdc4 rgba(255, 255, 255, 0.1);
}
</style>